<template>
  <template v-for="(user, index) in users" :key="String(user.userId)">
    <ActivityUserHoverTooltip
      :user-id="String(user.userId ?? '')"
      :user-name="String(user.userNm ?? '')"
    >
      <span class="plan-user-name">{{ user.userNm }}</span>
    </ActivityUserHoverTooltip>
    <span v-if="index < users.length - 1" class="plan-user-name__sep">, </span>
  </template>
</template>

<script setup lang="ts">
import ActivityUserHoverTooltip from '~/components/domain/Activity/ActivityUserHoverTooltip.vue';

defineProps({
  users: {
    type: Array as () => Array<Record<string, unknown>>,
    default: () => [],
  },
});
</script>

<style scoped lang="scss">
:deep(.activity-user-hover-tooltip__trigger) {
  display: inline;
}

.plan-user-name {
  cursor: default;
}

.plan-user-name__sep {
  color: inherit;
}
</style>
